import { ErrorHandler, Injectable } from '@angular/core';
//import { TelemetryService } from './telemetry.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoggingService implements ErrorHandler {
  public isTelemetryEnabled = new BehaviorSubject<boolean>(false);
  constructor(
    //private telemetryService: TelemetryService
  ) { 
    // Set up global error handler
    window.onerror = (message, source, lineno, colno, error) => {
      console.error('Global error occurred:', message, source, lineno, colno, error);
      // Additional global error handling logic
      return true; // Prevent default browser error handling
    };
  }

  handleError(error: any): void {
    console.log('handle error', error);
    // if (this.isTelemetryEnabled.value) {
    //   this.telemetryService.logException(error, 3);
    // } 
    // else {
      console.log('An unhandled exception occured.', error);
    //}    
  }

  // handleTrace(message: string, properties?: { [key: string]: any }){
  //   if (this.isTelemetryEnabled.value) {
  //     this.telemetryService.logTrace(message, properties);
  //   } 
  // }
}
